// 我的课程
export default [
  {
    path: "/myCourse",
    name: "myCourse",
    meta: { title: "我的课程" },
    component: () => import("../views/myCourse/index"),
    children: [
      {
        path: "/myCourse/myCourseList",
        meta: { title: "课程列表", isMenu: true },
        component: () => import("../views/myCourse/myCourseList"),
      },
    ],
  },
]
